<script>
import Sales from "../Sales.vue";
import { mapActions } from "vuex";

import BaseCustomerDialogSelector from "@/components/shared/BaseDialogSelectors/BaseCustomerDialogSelector.vue";
import BaseLocationDialogSelector from "@/components/shared/BaseDialogSelectors/BaseLocationDialogSelector.vue";
import BaseRegisterDialogSelector from "@/components/shared/BaseDialogSelectors/BaseRegisterDialogSelector.vue";
import BaseUserDialogSelector from "@/components/shared/BaseDialogSelectors/BaseUserDialogSelector.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";

export default {
  extends: Sales,
  components: {
    BaseCustomerDialogSelector,
    BaseLocationDialogSelector,
    BaseRegisterDialogSelector,
    BaseUserDialogSelector,
    DateRangePicker,
  },
  page: {
    title: "Orders",
  },
  data() {
    return {
      modelName: { singular: "Order", plural: "Orders", code: "ORD" },

      sales: {},
    };
  },
  methods: {
    ...mapActions("sales", ["fetchOrders", "archiveOrder"]),
    ...mapActions("application", ["setIsTableLoading"]),

    async archive(id, value) {
      try {
        await this.archiveOrder({
          id: id,
          archive: value,
        });
        this.query();
      } catch {}
    },

    create() {
      this.$router.push({
        name: "Edit Order",
      });
    },

    edit(id) {
      this.$router.push({
        name: "Edit Order",
        params: {
          id: id,
        },
      });
    },

    query() {
      this.setIsTableLoading(true);
      this.fetchOrders({
        organisation: this.getCurrentOrganisation.id,
        ...this.query_params,
      }).then((res) => {
        this.sales = res.data;
      }).catch((error) => {
      }).finally(() => {
        this.setIsTableLoading(false);
      });
    },
  },
  mounted() {
    this.query();
  },
};
</script>

<template>
  <div>
    <PageHeader
      :modelName="modelName"
      @create="create"
      v-model="query_params.search"
    >
      <template v-slot:filters>
        <base-toggle-button-group id="archived" label="Void" variant="primary" v-model="query_params.archived" :options="void_options"/>
        <DateRangePicker :start.sync="query_params.date_start" :end.sync="query_params.date_end"/>
        <base-input label="Payment Deadline" type="date" v-model="query_params.payment_deadline" />
        <base-input label="Delivery Date" type="date" v-model="query_params.delivery_date" />
        <BaseCustomerDialogSelector v-model="query_params.customer" disableAdd />
        <BaseLocationDialogSelector v-model="query_params.location" disableAdd />
        <BaseRegisterDialogSelector v-model="query_params.register" :disabled="!query_params.location" :location="query_params.location" :placeholder="query_params.location ? null : 'Select a Location first'" disableAdd />
        <BaseUserDialogSelector label="Sales Person" v-model="query_params.sales_person" />
        <base-sale-selector label_name="Parent" v-model="query_params.parent" :document_type="['Quote']" />
        <!-- <base-price_list-selector v-model="query_params.price_list" /> -->
        <base-input type="multiselect" id="status_filter" label="Status" v-model="query_params.status" :options="['Draft', 'Confirmed']" />
        <BaseUserDialogSelector label="Created By" v-model="query_params.created_by" />
        <BaseUserDialogSelector label="Edited By" v-model="query_params.edited_by" />
      </template>
    </PageHeader>

    <base-card>
      <base-table
        ref="table"
        :data_="sales"
        :fields="fields"
        :modelName="modelName"
        @archive="archive"
        @edit="edit"
        @page_change="query_params.page = $event"
        @page_size_change="query_params.page_size = $event"
        @ordering_change="query_params.ordering = $event"
      />
    </base-card>
  </div>
</template>
